import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ConfigurationType } from './../configuration';
import { ConfigurationService } from './../configuration.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-configuration-type',
  templateUrl: './view-configuration-type.component.html',
  styleUrls: ['./view-configuration-type.component.scss']
})
export class ViewConfigurationTypeComponent implements OnInit, OnDestroy {
  @Input() display: boolean;
  @Output() displayChange: EventEmitter<any> = new EventEmitter();

  @Input() data: any;
  @Input() group: boolean;

  loading: boolean;
  // data: ConfigurationType[];
  subscription: Subscription;
  title: string;

  rowGroupMetadata = {};

  constructor(private _configService: ConfigurationService) { }

  ngOnInit() {
    this.loading = true;
    if (this.data) {
      for (let i = 0; i < this.data.length; i++) {
        let rowData = this.data[i];
        let GroupName = rowData.GroupName;
        if (i == 0) {
            this.rowGroupMetadata[GroupName] = { index: 0, size: 1 };
        }else{
          let previousRowData = this.data[i - 1];
          let previousRowGroup = previousRowData.GroupName;
          if (GroupName === previousRowGroup)
              this.rowGroupMetadata[GroupName].size++;
          else
              this.rowGroupMetadata[GroupName] = { index: i, size: 1 };
        }
      }

      this.loading = false;
  }
}

  close() {
    this.displayChange.emit(false);
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
